import {
  isFile,
  isCalendar,
  isEpharmacyPrescription,
  isCmsContent,
  isResourceLink,
} from 'APP/Lib/MessagingHelpers'

import AddressPicker from 'APP/Components/Chat/AddressPicker'
import AddToCalendar from 'APP/Components/Chat/AddToCalendar'
import BodyPart from 'APP/Components/Chat/BodyPart'
import CarePlan from 'APP/Components/Chat/CarePlan'
import Charge from 'APP/Components/Chat/Charge'
import CmsContent from 'APP/Components/Chat/CmsContent'
import EpharmacyPrescription from 'APP/Components/Chat/EpharmacyPrescription'
import File from 'APP/Components/Chat/File'
import ResourceLink from 'APP/Components/Chat/ResourceLink'
import TextMessage from 'APP/Components/Chat/TextMessage'
import MicroApp from 'APP/Components/Chat/MicroApp'
import PostWithMissingData from 'APP/Components/Chat/PostWithMissingData'
import VideoCall from 'APP/Components/Chat/VideoCall'
import TypingIndicator from 'APP/Components/Chat/TypingIndicator'
import Booking from 'APP/Components/Chat/Booking'
import SelfNavigation from 'APP/Components/Chat/SelfNavigation'
import Checkout from 'APP/Components/Chat/Checkout'

// @ts-expect-error TODO: type post when we've introduced proper models for it
export const getPostComponent = (post) => {
  if (!post) {
    return TextMessage
  }

  // support legacy type for single choice
  const isSingleChoice =
    post?.props?.type === 'prompt_choice_single' || post?.props?.type === 'multiChoiceQuestion'

  if (isFile(post)) {
    return File
  }
  if (post.actionType === 'charge') {
    return Charge
  }
  if (post.actionType === 'carePlan') {
    return CarePlan
  }
  if (post.actionType === 'videoCall') {
    return VideoCall
  }
  if (post?.props?.type === 'findAddress.v1' || post?.props?.type === 'prompt_address') {
    return AddressPicker
  }
  // TODO: Maintain for backwards compatibility
  if (post?.props?.type === 'microAppCta.v1') {
    return MicroApp
  }

  if (post?.props?.type === 'prompt_self_navigation') {
    return SelfNavigation
  }

  if (post?.props?.type === 'prompt_booking') {
    return Booking
  }

  if (post?.props?.type === 'prompt_checkout') {
    return Checkout
  }

  if (isSingleChoice && isEpharmacyPrescription(post)) {
    return EpharmacyPrescription
  }
  if (isSingleChoice && isCmsContent(post)) {
    return CmsContent
  }
  if (isSingleChoice && !isCalendar(post)) {
    return TextMessage
  }
  if (isSingleChoice && isCalendar(post)) {
    return AddToCalendar
  }
  if (isResourceLink(post)) {
    return ResourceLink
  }
  if (post.props?.missingData) {
    return PostWithMissingData
  }
  if (post?.props?.type === 'bodyPartSelector.v1') {
    // only used in legacy /r intake flow
    return BodyPart
  }
  if (post?.props?.type === 'typingIndicator') {
    return TypingIndicator
  }

  return TextMessage
}
